import { Chip, ChipColorEnum } from '@acceso/design-system';

type TStateClasses = {
  [key: string]: {
    color: ChipColorEnum;
    text: string;
  };
};

const STATE_CLASSES: TStateClasses = {
  active: { color: ChipColorEnum.ACTIVO, text: 'Activo' },
  inactive: { color: ChipColorEnum.INACTIVO, text: 'Inactivo' },
};

type TStateActiveInTable = {
  status: 'active' | 'inactive';
};

export function StateActiveInTable({ status }: TStateActiveInTable) {
  return (
    <Chip className="w-fit uppercase" color={STATE_CLASSES[status].color}>
      {STATE_CLASSES[status].text}
    </Chip>
  );
}
